import { useMemo } from "react";

import { DropdownItemModel, AssetType } from "@interfaces/index";
import { useBusinessType } from "@hooks/index";
import { AssetItem, Dropdown } from "@components/index";

export const AssetTypeSelector = ({
  businessId = "",
  excludeTypes,
  height = "medium",
  value = "",
  onSetAssetType,
  error,
  dataTestid,
}: {
  businessId?: string;
  excludeTypes?: AssetType[];
  height?: "small" | "medium";
  value?: string;
  onSetAssetType?: (assetType: string) => void;
  error?: string;
  dataTestid?: string;
}) => {
  const businessType = useBusinessType(businessId);

  const types: DropdownItemModel[] = useMemo(() => {
    const allTypes = [
      {
        id: "vehicle",
        title: <AssetItem type="vehicle" />,
      },
      {
        id: "rental_property",
        title: <AssetItem type="rental_property" />,
      },
      {
        id: "other",
        title: <AssetItem type="other" />,
      },
    ];

    switch (businessType) {
      case "landlord":
        return allTypes.filter(({ id }) =>
          ["vehicle", "rental_property", "other"].includes(id),
        );
      case "driving_instructor":
      case "other":
      default:
        return allTypes.filter(({ id }) => ["vehicle", "other"].includes(id));
    }
  }, [businessType]);

  const handleSelectAssetType = (id: string) => {
    if (onSetAssetType) {
      onSetAssetType(id);
    }
  };

  return (
    <Dropdown
      items={
        excludeTypes?.length
          ? types.filter(({ id }) => !excludeTypes.includes(id as AssetType))
          : types
      }
      label="Asset type"
      showClearButton
      height={height}
      value={value}
      onSelect={handleSelectAssetType}
      error={error}
      dataTestid={dataTestid}
    />
  );
};
